import {AfterViewInit, ChangeDetectorRef, Component, ElementRef,  Input,  NgZone,  Renderer2,  ViewChild} from '@angular/core';

import { OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalConstants } from 'src/app/iwgcommon/global-constants';
import { ListComponent } from 'src/app/iwgcommon/list/list.component';
import { QuotesDialogComponent } from 'src/app/quotes/quotes-dialog/quotes-dialog.component';
import { TransferQuotesDialogComponent } from 'src/app/quotes/transfer-quotes-dialog/transfer-quotes-dialog.component';
import { AssignmentDialogService } from 'src/app/shared/services/assignment-dialog.service';
import { AssignmentService } from 'src/app/shared/services/assignment.service';
import { CsvDataService } from 'src/app/shared/services/csv-export.service';
import { IWGSharedService } from '../../shared/services/shared.service';
import { UserService } from 'src/app/shared/services/user.service';
import { Utils } from 'src/app/shared/utils/utils';
import {QuoteDialogService} from '../../shared/services/quote-dialog.service';


@Component({
  selector: 'app-assignment-table',
  templateUrl: './assignment-table.component.html',
  styleUrls: ['./assignment-table.component.scss']
})

export class AssignmentTableComponent extends ListComponent implements  OnInit, AfterViewInit{


  globalScopes: any;
  fileName = '';
  isManager=true;
  hideColsInExport: number[];
  exportColDetails: any;
  @Input() hideFilters: boolean = false;

  constructor(private router: Router, public assignmentService: AssignmentService, utils: Utils,
              private quoteDialogService: QuoteDialogService,
              private assignmentDialog: AssignmentDialogService, public dialog: MatDialog, private csvDataService: CsvDataService,
              userService: UserService, renderer: Renderer2, private changeDetectorRef: ChangeDetectorRef,  zone: NgZone, public sharedService : IWGSharedService) {
    super(assignmentService, utils, renderer, userService, zone,sharedService);
    this.globalScopes = GlobalConstants.globalScopes;
  }

  ngOnInit(): void {
  
    super.ngOnInit();
    this.listColumns = ['IDCol', 'TitleLabel', 'EndClient', 'WorkerLabel', 'ContractorCompany', 'Manager', 'Country',
      'State', 'BusinessName', 'JobTitleLabel', 'Status', 'EvaluationStatus', 'QuestionnaireStatus', 'Start', 'Submitted',
      'Recommendation', 'RecommendationDate',
      'ExpectedEnd', 'ActualEnd', 'Hours', 'RegularHours', 'OT', 'DT', 'Expenses', 'PayRate',
      'PayStructure', 'ProjectAmount', 'PartnerInvoiceTotalAmount', 'PayAmount', 'BillAmount', 'OprMenu'];

    if (this.state.service == 3) {
      this.fileName = 'MyVista_Evaluations_Export.csv';
    } else if (this.state.service == 2) { 
      this.fileName = 'MyVista_Engagements_Export.csv';
    } else {
      this.fileName = 'MyVista_Assignments_Export.csv';
    }
    var role = this.userService.getRole();
    if (role == 'Worker') {
        this.isManager = false;
    }
    this.updateLabels();
    this.generateListColumns();
    this.setStateParams();
    this.getItems();

    this.exportColDetails = {
      'IDCol': {'heading': '"ID"', 'dataFieldName': 'DisplayID'}, 
      'TitleLabel': { 'heading': this.assignmentLabel, 'dataFieldName': 'Title', 'dataFormat': 'htmDecode'}, 
      'EndClient': {'heading': 'End Client', 'dataFieldName': 'EndClientName'}, 
      'WorkerLabel': {'heading': this.WorkerLabel, 'dataFieldName': 'Worker'}, 
      'ContractorCompany': {'heading': 'Contractor Company', 'dataFieldName': 'WorkerCompanyName'}, 
      'Manager': {'heading': 'Manager', 'dataFieldName': 'Manager'}, 
      'Country': {'heading': 'Country', 'dataFieldName': 'Country'}, 
      'State': {'heading': 'State', 'dataFieldName': 'Region'}, 
      'BusinessName': {'heading': 'Business Name', 'dataFieldName': 'WorkerCompanyName'}, 
      'JobTitleLabel': { 'heading': this.JobTitleLabel, 'dataFieldName': 'JobTitle', 'dataFormat': 'htmDecode'}, 
      'Status': {'heading': 'Status', 'dataFieldName': 'Status'}, 
      'EvaluationStatus': {'heading': 'Evaluation Status', 'dataFieldName': 'Status'}, 
      'QuestionnaireStatus': {'heading': 'Questionnaire Status', 'dataFieldName': 'QuestionnaireStatus'}, 
      'Start': {'heading': 'Start', 'dataFieldName': 'StartDate', 'dataFormat': 'date'}, 
      'Submitted': {'heading': 'Submitted', 'dataFieldName': 'CreationDate', 'dataFormat': 'date'}, 
      'Recommendation': {'heading': 'Recommendation', 'dataFieldName': 'Recommendation'}, 
      'RecommendationDate': {'heading': 'Recommendation Date', 'dataFieldName': 'EvaluationDate', 'dataFormat': 'date'}, 
      'ExpectedEnd': {'heading': 'Expected End', 'dataFieldName': 'ExpectedEndDate', 'dataFormat': 'date'}, 
      'ActualEnd': {'heading': 'Actual End', 'dataFieldName': 'EndDate', 'dataFormat': 'date'},
      'Hours': {'heading': 'Hours', 'dataFieldName': 'Hours', 'dataFormat': 'decimal'}, 
      'RegularHours': {'heading': 'Regular', 'dataFieldName': 'Reg', 'dataFormat': 'decimal'}, 
      'OT': {'heading': 'OT', 'dataFieldName': 'OT', 'dataFormat': 'decimal'}, 
      'DT': {'heading': 'DT', 'dataFieldName': 'DT', 'dataFormat': 'decimal'}, 
      'Expenses': {'heading': 'Expenses', 'dataFieldName': 'Expenses', 'dataFormat': 'currency', 'currencyCodeField': 'EntityCurrencyCode'}, 
      'PayRate': {'heading': 'Pay Rate', 'dataFieldName': 'Payrate'}, 
      'PayStructure': {'heading': 'Pay Structure', 'dataFieldName': 'SalaryPerTimeframeStructure'}, 
      'ProjectAmount': {'heading': 'Project Amount', 'dataFieldName': 'ProjectAmount'}, 
      'PartnerInvoiceTotalAmount': {'heading': 'Pay Amount', 'dataFieldName': 'PartnerInvoiceTotal'}, 
      'PayAmount': {'heading': 'Pay Amount', 'dataFieldName': 'Pay', 'dataFormat': 'currency', 'currencyCodeField': 'EntityCurrencyCode'},
      'BillAmount': {'heading': 'Bill Amount', 'dataFieldName': 'Bill', 'dataFormat': 'currency', 'currencyCodeField': 'EntityCurrencyCode'},
    }

  }

  generateListColumns(): void {

    this.displayedColumns = [...this.listColumns];

    if (!this.userService.getAllowEndClients()) {
      this.removeColFromDisplay('EndClient');
    }

    if (this.ComplianceFormat) {
      this.removeColFromDisplay('Start');
      this.removeColFromDisplay('ExpectedEnd');
      this.removeColFromDisplay('ActualEnd');
    } else {
      this.removeColFromDisplay('ContractorCompany');
      this.removeColFromDisplay('Recommendation');
      this.removeColFromDisplay('RecommendationDate');
      this.removeColFromDisplay('Submitted');
    }

  
      if(this.state.global_scope===3||this.state.global_scope==="3" || this.state.isUSA ==="true"){
      this.removeColFromDisplay('Country');
    } 
    else { // State/ Region tobe displayed for all 2 tabs - IWG-2274
      this.removeColFromDisplay('State');
    }

    if (this.service != 2) {
      this.removeColFromDisplay('BusinessName');
      this.removeColFromDisplay('PayStructure');
      this.removeColFromDisplay('ProjectAmount');
      this.removeColFromDisplay('PartnerInvoiceTotalAmount');
    }

   

    if(this.state.isUSA==undefined){
      this.state.isUSA="false";
    }
    if ((this.state.isUSA ==="true" || (this.state.global_scope === "3" || this.state.global_scope ===3)) && this.service === 1) {
      this.removeColFromDisplay('JobTitleLabel');
    } else {
      this.removeColFromDisplay('Expenses');
      this.removeColFromDisplay('PayAmount');
    }    
  
    if((this.service===1 && (this.state.global_scope==="1" && this.state.isUSA ==="false"))
    ||(this.service===1 && (this.state.global_scope===1 && this.state.isUSA ==="false")) 
    ||( this.service===1 &&this.state.global_scope==="2")
    ||( this.service===1 &&this.state.global_scope===2)
    || this.service===3 || this.service===2 ){
      this.removeColFromDisplay('Hours');
      this.removeColFromDisplay('RegularHours');
      this.removeColFromDisplay('OT');
      this.removeColFromDisplay('DT');
 
    }
    
    // if(this.state.global_scope !== "3" || this.state.global_scope !== 3) {
    //   this.removeColFromDisplay('State');
    // }
    if (!this.showRates) {
      this.removeColFromDisplay('PayRate');
    }   

    if (((!this.showRates || !this.isManager) && !this.USEORAssignmentFormat)) { 
      this.removeColFromDisplay('BillAmount');
    }

    if (this.service == 3) {
      this.removeColFromDisplay('Status');
    } else {
      this.removeColFromDisplay('EvaluationStatus');
      this.removeColFromDisplay('QuestionnaireStatus');
    }
    
  }

    ngAfterViewInit(): void {
      super.ngAfterViewInit();
    }

    showTransferAssignmentDialog(ev=null, assignmentId=null, quoteId=null, transferType=null, isExistingTransferAssignment=null): void {
      if (transferType == 'AOR') {        
        this.assignmentDialog.show(ev, assignmentId, quoteId, null, null, 2, true, isExistingTransferAssignment);
      }
      if (transferType == 'EOR' && assignmentId) {       
        this.quoteDialogService.showTransferEOR(ev, assignmentId, 1);
      }
    }

    showTransferEorQuoteDialog(ev, existingAssignment, assignmentId, serviceId) {
      this.loading = false;
      this.sharedService.isBlurredBg.next(true);
      const dialogRef = this.dialog.open(TransferQuotesDialogComponent, {
        panelClass: ['iwg-form-dialogfull'], maxWidth:"100%",
        data :{
          existingAssignment: existingAssignment,
          existingEvaluationId: assignmentId,
          existingServiceId: serviceId
        }
      });
      
      dialogRef.afterClosed().subscribe(result => {
        this.sharedService.isBlurredBg.next(false);       
      });
      return;
    }

   
    edit(ev=null, item=null, extraParam=null){
   
      this.assignmentDialog.show(ev,item,extraParam);
    }

    exportTable () {
      let exportColList = [];

      if (this.service == 2) {
        exportColList = ['IDCol', 'TitleLabel'];
        if(this.userService.getAllowEndClients()) {
          exportColList.push.apply(exportColList, ['EndClient']);
        }
        exportColList.push.apply(exportColList, ['WorkerLabel', 'Manager', 'Country', 'State', 'BusinessName', 
          'JobTitleLabel', 'Status', 'Start', 'ExpectedEnd', 'ActualEnd', 'PayStructure', 
          'ProjectAmount', 'PartnerInvoiceTotalAmount']);

      } else {       
       
        if ((this.state.isUSA ==="true" || this.state.global_scope === "3") && this.service === 1) {
          exportColList = ['IDCol', 'TitleLabel'];
          if(this.userService.getAllowEndClients()) {
            exportColList.push.apply(exportColList, ['EndClient']);
          }
          exportColList.push.apply(exportColList, ['WorkerLabel', 'Country', 'State', 
          'JobTitleLabel', 'Status', 'Start', 'ExpectedEnd', 'ActualEnd', 'Hours', 'RegularHours', 'OT', 'DT', 
          'Expenses', 'PayAmount', 'BillAmount']);
        } else {
          if (this.service == 3) {
            exportColList = ['IDCol', 'TitleLabel'];
            if(this.userService.getAllowEndClients()) {
              exportColList.push.apply(exportColList, ['EndClient']);
            }
            exportColList.push.apply(exportColList, ['WorkerLabel', 'ContractorCompany','Manager','Country', 'State', 
              'JobTitleLabel', 'EvaluationStatus', 'QuestionnaireStatus', 'Submitted', 'Recommendation', 'RecommendationDate']);
          } else {
            exportColList = ['IDCol', 'TitleLabel'];
            if(this.userService.getAllowEndClients()) {
              exportColList.push.apply(exportColList, ['EndClient']);
            }
            exportColList.push.apply(exportColList, ['WorkerLabel', 'Country', 'State', 
            'JobTitleLabel', 'Status', 'Start', 'ExpectedEnd', 'ActualEnd', 'PayRate', 'BillAmount']);
          }          
        }        
      }      
      this.csvDataService.exportToCsv(this.fileName, this.items, this.exportColDetails, exportColList);
    }

    navigatePage(assignmentId, queryParams) {
      this.router.navigate(["assignments",assignmentId],{queryParams:queryParams})
    }
}